<div 
  class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 h-lvh md:h-auto" 
  *transloco="let t; prefix: 'property-details.hero-section.modal-image-gallery'"
>
  <div class="flex flex-col bg-white rounded-small px-6 py-10 h-full md:h-auto gap-2 max-h-[100vh] justify-between">
    @if (!displayingImage) {
      <div class="flex justify-between gap-4">
        <h4 class="h4 text-base sm:text-lg md:text-xl">
          {{t('title') + ' ' + title + ' ' + t('sqare-meters')}}
        </h4>
        <button (click)="closeModal()" class="p-2">
          <i class="icon-close text-xl"></i>
        </button>
      </div>

      <div class="h-[744px] md:h-auto overflow-y-auto pt-2">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          @for (photo of this.displyedItems; track $index) {
            <div 
              class="overflow-y-auto relative group/property-modal hover:cursor-pointer" 
              (click)="viewCarousel($index)" 
              *transloco="let t; prefix: 'property-details.hero-section.modal-image-gallery.image-item'"
            >
              <img 
                [src]="photo.uri" 
                class="rounded-small w-full sm:w-[343.59px] h-[188px] object-cover object-center self-stretch"
              />
              <div class="absolute group-hover/property-modal:opacity-100 flex opacity-0 transition-all inset-0 bg-black/40 rounded-small">
                <div class="flex flex-col flex-1 gap-2 items-center justify-center text-tone-01">
                    <button class="icon-full-screen text-[32px]"></button>
                    <p class="font-semibold text-center">
                      {{t('infoText.fullScreenSlideshow')}}
                    </p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="flex flex-col justify-between items-center pt-6 gap-2">
        <p class="text-tone-09 text-sm">
          {{ photos?.count ?? 0 }} {{t('text.photos')}}
        </p>
        <div class="flex flex-wrap gap-2 gap-4 justify-center">
          <button class="btn-primary-sm" (click)="onCallbackClick()">
            {{t('anchors.callbackRequest')}}
          </button>
          <button *ngIf="!isSold" class="btn-secondary-sm" (click)="onAskTourClick()">
            {{t('anchors.walkthroughRequest')}}
          </button>
        </div>
      </div>
    } @else {
      <ng-container *ngIf="photos">
        <div class="flex justify-between items-center">
          <div class="flex gap-x-4 items-center mb-2">
            <i (click)="exitCarousel()" class="icon-arrow-left cursor-pointer"></i>
            <span class="text-black text-lg">
              {{ photos.items?.[currentPhotoIndex]?.tag }}
            </span>
          </div>
          <button (click)="closeModal()" class="p-2">
            <i class="icon-close text-xl"></i>
          </button>
        </div>

        <div class="bg-white rounded-small p-6 relative">
          <div class="relative">
            <img 
              class="rounded-small w-full max-h-[60vh] object-cover object-center img-disable-context"
              [src]="getLargeImageUri(currentPhotoIndex)"
            />
            
            <!-- Previous button (left side) -->
            <button 
              class="absolute left-0 top-1/2 -translate-y-1/2 btn-primary border flex items-center justify-center rounded-full p-2 w-[48px] h-[48px] ml-2"
              (click)="previous()"
              [disabled]="currentPhotoIndex === 0"
            >
              <i class="icon-arrow-left text-lg text-black"></i>
            </button>
            
            <!-- Next button (right side) -->
            <button 
              class="absolute right-0 top-1/2 -translate-y-1/2 btn-primary border flex items-center justify-center rounded-full p-2 w-[48px] h-[48px] mr-2"
              (click)="next()"
              [disabled]="currentPhotoIndex === (photos.count && photos.count - 1)"
            >
              <i class="icon-arrow-right text-lg text-black"></i>
            </button>
          </div>
        </div>

        <div class="flex flex-row justify-center items-center px-2 mt-4 gap-4">
          <span class="text-base font-medium">
            <span class="text-black">{{ currentPhotoIndex + 1 }}</span>
            <span class="mx-1">-</span>
            <span class="text-tone-07">{{ photos.count }}</span>
          </span>
        </div>
      </ng-container>
    }
  </div>
</div>